import { render, staticRenderFns } from "./site-internet-pourquoi-le-formulaire-plutot-que-le-mail.vue?vue&type=template&id=7f9133fc&"
import script from "./site-internet-pourquoi-le-formulaire-plutot-que-le-mail.vue?vue&type=script&lang=js&"
export * from "./site-internet-pourquoi-le-formulaire-plutot-que-le-mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports